import { logError } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Checkout } from '@com-delta-idp/mnx-sky-club-ui';
import {
  AEMErrorMessage,
  checkErrors,
  getEmptyContent,
  isDisplay,
  isError,
  isValidData
} from '@com-delta-idp/mnx-skymiles-shared';
import { GenericLabel } from '@com-delta-omnichannel/aura';
import {
  AEMCheckoutContent,
  AddToCart,
  CHECKOUT,
  REDIRECT,
  SKY_CLUB_ERROR
} from '../models';

export const getCheckout = (
  aem: AEMCheckoutContent | undefined,
  addToCart: AddToCart | undefined,
  value: string | undefined,
  aemErrorMessages: AEMErrorMessage[] | undefined,
  errors: (string | undefined)[],
  featureFlag: boolean | undefined
): Checkout => {
  try {
    if (checkErrors(errors, aemErrorMessages)) {
      return isError<Checkout>(
        errors.find((error) => error != undefined) as string,
        aemErrorMessages as AEMErrorMessage[],
        featureFlag
      );
    }
    return isValidData<
      AEMCheckoutContent,
      [AEMCheckoutContent | undefined, boolean | undefined]
    >('total', aem, featureFlag)
      ? adaptCheckout(
          aem as AEMCheckoutContent,
          addToCart,
          value,
          featureFlag as boolean
        )
      : isDisplay<Checkout>(featureFlag);
  } catch (error) {
    logError(
      error as Error,
      'DIGITAL_CUSTOMER_LOYALTY',
      'SKY_CLUB',
      'CHECKOUT'
    );
    return getEmptyContent<Checkout>(
      SKY_CLUB_ERROR,
      aemErrorMessages,
      true,
      true
    );
  }
};

export const adaptCheckout = (
  aem: AEMCheckoutContent,
  response: AddToCart | undefined,
  value: string | undefined,
  featureFlag: boolean
): Checkout => {
  return featureFlag
    ? {
        ...aem,
        price: getValue(aem.price, response, value),
        total: getValue(aem.total, response, value),
        showCheckout: getShowCheckout(response),
        loaded: true,
        disabled: !featureFlag
      }
    : getEmptyContent<Checkout>('', [], true, true);
};

export const getShowCheckout = (response: AddToCart | undefined): boolean => {
  return response?.addedToCart ? saveCartIdInSession(response) : false;
};

export const getValue = (
  content: GenericLabel,
  response: AddToCart | undefined,
  value: string | undefined
): GenericLabel => {
  return response?.addedToCart ? { ...content, subtitle: value } : content;
};

export const saveCartIdInSession = (addToCartResponse: AddToCart): boolean => {
  if (addToCartResponse.addedToCart) {
    const checkout = {
      action: REDIRECT,
      redirectUrl: location.href,
      cartId: addToCartResponse.cartId
    };
    sessionStorage.setItem(CHECKOUT, JSON.stringify(checkout));
  }
  return addToCartResponse.addedToCart;
};
